/**
 * Servicios del panel administrativo por compañía. La compañía efectiva viaja en la cabecera
 * X-Hayllis-Company que añade el interceptor de httpService (FTR-0012).
 */
import httpService from "./httpService.js";

const HAYLLIS_V2_BASE = "/api/hayllis/v2";

const unwrap = (response) => response?.data?.data ?? response?.data ?? {};

const toArray = (value) => (Array.isArray(value) ? value : []);

export const getApiErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.response?.data?.msg || fallback;

// Compañías que el actor puede administrar: fuente única del selector (FTR-0012).
export const getAdministrableCompanies = async () => {
  const response = await httpService.get(`${HAYLLIS_V2_BASE}/admin/companies`);
  const data = unwrap(response);
  return {
    companies: toArray(data?.companies),
    unrestricted: Boolean(data?.unrestricted),
  };
};

export const listCompanyEvents = async ({ idcompany, periodo }) => {
  const response = await httpService.get("/championshipsbycompany", {
    params: { idcompany, periodo },
  });
  return toArray(response.data);
};

export const updateCompanyEvent = async ({ idchampionship, payload }) => {
  const response = await httpService.patch(
    `${HAYLLIS_V2_BASE}/events/${idchampionship}`,
    payload
  );
  return unwrap(response)?.event;
};

export const listCompanySports = async (idcompany) => {
  const response = await httpService.get(
    `${HAYLLIS_V2_BASE}/companies/${idcompany}/sports`
  );
  return toArray(unwrap(response)?.sports);
};

export const listAllSports = async () => {
  const response = await httpService.get("/sports");
  return toArray(response.data);
};

export const listCompanies = async () => {
  const response = await httpService.get("/companies");
  return toArray(response.data);
};

export const createCompanySport = async ({ idcompany, idsport }) => {
  const response = await httpService.post(`${HAYLLIS_V2_BASE}/company-sports`, {
    idcompany,
    idsport,
  });
  return unwrap(response)?.relation;
};

export const updateCompanySport = async ({ idcompanysport, idcompany, idsport }) => {
  const response = await httpService.patch(
    `${HAYLLIS_V2_BASE}/company-sports/${idcompanysport}`,
    { idcompany, idsport }
  );
  return unwrap(response)?.relation;
};

export const deleteCompanySport = async (idcompanysport) => {
  const response = await httpService.delete(
    `${HAYLLIS_V2_BASE}/company-sports/${idcompanysport}`
  );
  return unwrap(response);
};

export const listCompanyInstitutions = async (idcompany, includeInactive = true) => {
  const response = await httpService.get(
    `${HAYLLIS_V2_BASE}/companies/${idcompany}/institutions`,
    { params: { includeInactive } }
  );
  return toArray(unwrap(response)?.institutions);
};

export const createCompanyInstitution = async (payload) => {
  const response = await httpService.post(
    `${HAYLLIS_V2_BASE}/institutions`,
    payload
  );
  return unwrap(response)?.institution;
};

export const updateCompanyInstitution = async ({ idinstitution, payload }) => {
  const response = await httpService.patch(
    `${HAYLLIS_V2_BASE}/institutions/${idinstitution}`,
    payload
  );
  return unwrap(response)?.institution;
};

export const deleteCompanyInstitution = async (idinstitution) => {
  const response = await httpService.delete(
    `${HAYLLIS_V2_BASE}/institutions/${idinstitution}`
  );
  return unwrap(response)?.institution;
};

export const listCompanyVenues = async (idcompany, includeInactive = true) => {
  const response = await httpService.get(
    `${HAYLLIS_V2_BASE}/companies/${idcompany}/venues`,
    { params: { includeInactive } }
  );
  return toArray(unwrap(response)?.venues);
};

export const createCompanyVenue = async (payload) => {
  const response = await httpService.post(`${HAYLLIS_V2_BASE}/venues`, payload);
  return unwrap(response)?.venue;
};

export const updateCompanyVenue = async ({ idsede, payload }) => {
  const response = await httpService.patch(
    `${HAYLLIS_V2_BASE}/venues/${idsede}`,
    payload
  );
  return unwrap(response)?.venue;
};

export const deleteCompanyVenue = async (idsede) => {
  const response = await httpService.delete(`${HAYLLIS_V2_BASE}/venues/${idsede}`);
  return unwrap(response)?.venue;
};

export const listDepartments = async () => {
  const response = await httpService.get("/departamento");
  return toArray(response.data);
};
